import styled from "styled-components";
import { MetaText } from "../atoms/Text";
import { ProgressBar, SubProgressBar } from "../atoms/ProgressBar";

const Wrap = styled.div`
  display: grid;
  gap: 6px;
`;

const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
`;

const Strong = styled.span`
  font-weight: 700;
  color: #111827;
`;

// export function CheckinProgress({ checked = 0, total = 0, label = "受付進�?" }) {
export function CheckinProgress({ total = 0, checked = 0, subUserTotal = 0, subUserChecked = 0 }) {
  const safeTotal = Math.max(0, Number(total) || 0);
  const safeChecked = Math.max(0, Math.min(safeTotal, Number(checked) || 0));
  const pct = safeTotal === 0 ? 0 : Math.round((safeChecked / safeTotal) * 100);

  const subSafeTotal = Math.max(0, Number(subUserTotal) || 0);
  const subSafeChecked = Math.max(0, Math.min(subSafeTotal, Number(subUserChecked) || 0));
  const subPct = subSafeTotal === 0 ? 0 : Math.round((subSafeChecked / subSafeTotal) * 100);

  return (
    <Wrap>
      <Row>
        {/* <MetaText>{label}</MetaText> */}
        <MetaText>
          全来場者：受付済み <Strong>{safeChecked}</Strong> 名 ／ 来場予定<Strong>{safeTotal}</Strong> 名（{pct}%）
        </MetaText>
      </Row>
      <ProgressBar value={pct} />
      <Row>
        <MetaText>
          サブユーザーのみ：受付済み <Strong>{subSafeChecked}</Strong> 名 ／ 来場予定<Strong>{subSafeTotal}</Strong> 名（{subPct}%）
        </MetaText>
      </Row>
      <SubProgressBar value={subPct} />
    </Wrap>
  );
}
